import session from './session';
import { socket, leaveRoom, joinRoom } from '../io';

// Swaps the persisted session to a different multi-brand profile and rebinds
// the socket room. Mirrors the shape of layouts/default/index.js
// `handleSelectSubCompany` so the existing brand-switcher dropdown keeps
// working after a notification-driven swap: `allProfiles` must stay nested in
// `userData` (the layout reads `session.get('userData').allProfiles` to gate
// its render) and `selectedSubCompany` must reflect the new profile.
export const switchActiveProfile = (targetUserId) => {
	if (!targetUserId) return false;

	const current = session.get('userData');
	if (current && current.id === targetUserId) return false;

	// Source of truth is whichever session key has the array — try the nested
	// `userData.allProfiles` first (set by handleSelectSubCompany after a prior
	// switch), fall back to the top-level key set on login.
	const profiles = (current && current.allProfiles)
		|| session.get('allProfiles')
		|| [];
	const next = profiles.find(p => p && p.id === targetUserId);
	if (!next) return false;

	const userData = {
		...next,
		allProfiles: profiles,
		bots: next.bots,
	};

	if (current && current.id) leaveRoom(current.id);

	session.set('token', next.token);
	session.set('userBots', next.bots || []);
	session.set('userData', userData);
	session.set('selectedSubCompany', next);

	if (socket && typeof socket.disconnect === 'function') {
		socket.disconnect();
		socket.connect();
	}
	joinRoom(next.id);

	return true;
};
